/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import { CircleCheckSolidV6, CircleInfoSolidV6, TriangleExclamationSolidV6 } from "@shared/v2/Icomoon";
import SellScoreTooltip, { normalizeSellScore } from "@shared/SellScoreTooltip";
import Tooltip from "@shared/v2/Tooltip";
import { capitalize } from "lodash";
import PropTypes from "prop-types";
import { useFeatureFlags } from "../../reducers/layoutReducer/selectors";


const AddressCard = ({
  containerClassName,
  addressType,
  addressStatus,
  preStatus,
  addressStatusClassName,
  streetAddress,
  secondaryAddress,
  country,
  cityStateZip,
  standardized,
  updatedDate,
  sellScore,
}) => {
  const featureFlags = useFeatureFlags();
  const normalizedSellScore = featureFlags?.sellScore && normalizeSellScore(sellScore);

  return (
    <div className={containerClassName}>
      <div className="tw-flex tw-flex-row tw-py-[8px] tw-justify-between tw-items-center">
        <div
          className={`tw-flex tw-gap-6px ${normalizedSellScore ? "tw-flex-col" : "tw-flex-row tw-items-center"}`}
        >
          {addressType && (
            <span className="tw-w-fit tw-text-12px tw-leading-[24px] tw-font-semibold tw-text-gray-75 tw-capitalize tw-rounded-[6px] tw-border-solid tw-border-1px tw-border-gray-15 tw-px-8px tw-flex tw-items-center">
              {addressType}
            </span>
          )}

          {(addressStatus || normalizedSellScore) && (
            <div className="tw-flex tw-items-start tw-gap-4px">
              {addressStatus && (
                <span
                  className={`tw-flex tw-items-center tw-rounded-[6px] tw-px-8px tw-text-12px tw-leading-[24px] tw-font-semibold ${addressStatusClassName}`}
                >
                  {addressStatus}
                  {preStatus && (
                    <Tooltip
                      className="tw-pl-[8px] tw-flex tw-items-center"
                      placement="right"
                      innerClassName="tw-max-w-[258px] !tw-text-left"
                      trigger={<CircleInfoSolidV6 className="tw-text-gray-50" />}
                      content={`Last known status: ${preStatus}`}
                    />
                  )}
                </span>
              )}
              {normalizedSellScore && (
                <span className="tw-flex tw-items-center tw-rounded-[6px] tw-bg-[#EEF9F9] tw-px-8px tw-text-12px tw-leading-[24px] tw-font-semibold tw-text-color-336e7b">
                  {capitalize(normalizedSellScore)} Sell Score
                  <SellScoreTooltip sellScore={normalizedSellScore} />
                </span>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="tw-flex tw-flex-col tw-text-14px tw-text-nowrap tw-mb-4px">
        <span>
          {streetAddress}
          {secondaryAddress ? `, ${secondaryAddress}` : null}
        </span>
        <div className="tw-flex tw-gap-4px tw-items-center">
          <span>
            {cityStateZip}
            {country ? `, ${country}` : ""}
          </span>
          {
            {
              standardized: (
                <Tooltip
                  placement="right"
                  innerClassName="tw-max-w-[258px] !tw-text-left"
                  trigger={<CircleCheckSolidV6 className="tw-text-brand-info" />}
                  content="This address has been verified and is in a standard format."
                />
              ),
              partialStandardized: null,
              undefined: null,
              null: null,
              invalid: (
                <Tooltip
                  placement="right"
                  innerClassName="tw-max-w-[258px] !tw-text-left"
                  trigger={<TriangleExclamationSolidV6 className="tw-text-[#E5941B]" />}
                  content="We aren't able to verify this address. Please edit and check for accuracy."
                />
              ),
            }[standardized]
          }
        </div>
      </div>

      {updatedDate ? (
        <span className="tw-text-gray-50 tw-text-12d">
          {preStatus ? "System updated status " : "Status received "}
          {new Date(updatedDate).toLocaleDateString("en-US", { timeZone: "UTC" })}
          {". "}
          <span
            className="tw-cursor-pointer tw-underline"
            onClick={() =>
              window.open(
                "https://www.brivityknowledge.com/docs/mls-address-statuses?highlight=address%20listing%20status",
                "_blank",
              )
            }
          >
            Learn More
          </span>
        </span>
      ) : null}
    </div>
  );
};

AddressCard.propTypes = {
  containerClassName: PropTypes.string,
  addressType: PropTypes.string,
  addressStatus: PropTypes.string,
  preStatus: PropTypes.string,
  addressStatusClassName: PropTypes.string,
  streetAddress: PropTypes.string,
  secondaryAddress: PropTypes.string,
  cityStateZip: PropTypes.string,
  country: PropTypes.string,
  standardized: PropTypes.bool,
  updatedDate: PropTypes.string,
  sellScore: PropTypes.string,
};

AddressCard.defaultProps = {
  containerClassName: "",
  addressType: "",
  preStatus: "",
  addressStatus: "",
  addressStatusClassName: "",
  streetAddress: "",
  secondaryAddress: "",
  cityStateZip: "",
  country: null,
  standardized: false,
  updatedDate: "",
  sellScore: "",
};

export default AddressCard;
